import ACTION_ITEMS from './actionItems';

const initialState = {
  candidateInfo: null,
  error: false,
};

export const candidateVerifyReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case ACTION_ITEMS.CANDIDATE_VERIFY.INFO.SET: {
      newState = {
        ...state,
        candidateInfo: action.payload.candidate,
        error: false,
      };
      break;
    }

    case ACTION_ITEMS.CANDIDATE_VERIFY.INFO.ERROR: {
      newState = {
        ...state,
        error: true,
      };
      break;
    }

    default:
      newState = state;
      break;
  }

  return newState;
};
